import { Alert } from '@mui/material';
import { PageHeader } from '../components/PageHeader';
import { useWorkspace } from '../workspace-context';
import { PublishingWorkspace } from './TelegramPublishing';

export function TelegramPage() {
  const { activeWorkspace } = useWorkspace();
  return (
    <>
      <PageHeader title="Телеграм" description="Публикация анкет по городам и расписанию." />
      {activeWorkspace ? (
        <PublishingWorkspace key={activeWorkspace.id} workspaceId={activeWorkspace.id} />
      ) : (
        <Alert severity="info">Выберите рабочее пространство.</Alert>
      )}
    </>
  );
}
